module.exports = __webpack_public_path__ + "img/machine.ce65ddb6.png";